"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHintedOverflowText = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _useDetectElementChange = require("../common/useDetectElementChange");
var useHintedOverflowText = exports.useHintedOverflowText = function useHintedOverflowText(_ref) {
  var isHintedEllipsis = _ref.isHintedEllipsis,
    ref = _ref.ref;
  var internalRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOverflowing = _useState2[0],
    setIsOverflowing = _useState2[1];
  var combineRefs = (0, _react.useCallback)(function (node) {
    internalRef.current = node;
    if (node && isHintedEllipsis) {
      var isOverflowingHorizontally = node.scrollWidth > node.clientWidth;
      var isOverflowingVertically = node.scrollHeight > node.clientHeight;
      setIsOverflowing(isOverflowingHorizontally || isOverflowingVertically);
    }
    if (typeof ref === 'function') {
      ref(node);
    } else if (ref) {
      ref.current = node;
    }
  }, [ref, isHintedEllipsis]);
  var detectTextOverflow = (0, _react.useCallback)(function () {
    var element = internalRef.current;
    if (!element) {
      return;
    }
    var isOverflowingHorizontally = element.scrollWidth > element.clientWidth;
    var isOverflowingVertically = element.scrollHeight > element.clientHeight;
    setIsOverflowing(isOverflowingHorizontally || isOverflowingVertically);
  }, []);
  (0, _useDetectElementChange.useDetectElementChange)({
    element: internalRef.current,
    callback: isHintedEllipsis ? detectTextOverflow : null
  });
  return {
    combineRefs: combineRefs,
    isOverflowing: isOverflowing
  };
};
//# sourceMappingURL=useHintedOverflowText.js.map